var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, ViewChild } from '@angular/core';
import { ElementSettingModalBase } from '../base/element-setting-modal-base';
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { DynamicDisplayModel } from '../../../../shared/dynamic-conduct-model/dynamic-display/dynamic-display-model';
import { ColumnResizingTool } from '../../diagram/tools/ColumnResizingTool';
import { RowResizingTool } from '../../diagram/tools/RowResizingTool';
var TableSettingComponent = /** @class */ (function (_super) {
    __extends(TableSettingComponent, _super);
    function TableSettingComponent(injector, changeDetector, bsModalRef) {
        var _this = _super.call(this, injector, 'PolygonSettingModal') || this;
        _this.changeDetector = changeDetector;
        _this.bsModalRef = bsModalRef;
        _this._onClosed = new Subject();
        return _this;
    }
    Object.defineProperty(TableSettingComponent.prototype, "allSettings", {
        get: function () {
            return this.arg.allSettings;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableSettingComponent.prototype, "generalSetting", {
        get: function () {
            return this.allSettings.generalSetting;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableSettingComponent.prototype, "configureId", {
        get: function () {
            return this.arg.configureId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableSettingComponent.prototype, "viewWidth", {
        get: function () {
            return this.arg.viewWidth;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableSettingComponent.prototype, "viewHeight", {
        get: function () {
            return this.arg.viewHeight;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableSettingComponent.prototype, "onClosed", {
        get: function () {
            return this._onClosed;
        },
        enumerable: true,
        configurable: true
    });
    TableSettingComponent.prototype.ngOnInit = function () {
        this.active = true;
        this.changeDetector.detectChanges();
        this.init(this.arg.model);
    };
    TableSettingComponent.prototype.init = function (editedComponent) {
        var _this = this;
        _super.prototype.init.call(this, editedComponent);
        setTimeout(function () {
            _this.displaySettingCmp.init(editedComponent);
        }, 500);
        this.loadDynamicSetting(editedComponent.model.data);
    };
    TableSettingComponent.prototype.loadDynamicSetting = function (componentData) {
        if (null != componentData.dynamicSetting) {
            this.dynamicSetting = _.cloneDeep(componentData.dynamicSetting);
            DynamicDisplayModel.addDefaultForRotationTranslation(this.dynamicSetting);
        }
        else {
            this.dynamicSetting = DynamicDisplayModel.default();
        }
    };
    TableSettingComponent.prototype.save = function () {
        if (!this.displaySettingCmp.save()) {
            this.saving = false;
            this.setActiveTab(2);
            return;
        }
        if (!this.saveDynamicSetting()) {
            this.saving = false;
            this.setActiveTab(1);
            return;
        }
        this.closeModal(this.allSettings);
    };
    TableSettingComponent.prototype.closeModal = function (data) {
        this.saving = false;
        this.active = false;
        this._onClosed.next(data);
        new ColumnResizingTool().updateAdornments(this.arg.model.model);
        new RowResizingTool().updateAdornments(this.arg.model.model);
        this._onClosed.complete();
        this.bsModalRef.hide();
    };
    TableSettingComponent.prototype.saveDynamicSetting = function () {
        if (!this.dynamicValidatoinResult) {
            if (this.dynamicSetting.isTranslation !== true) {
                delete this.dynamicSetting.horizontalTranslation;
                delete this.dynamicSetting.verticalTranslation;
            }
            else {
                if (this.dynamicSetting.isHorizontalTranslation !== true) {
                    delete this.dynamicSetting.horizontalTranslation;
                }
                if (this.dynamicSetting.isVerticalTranslation !== true) {
                    delete this.dynamicSetting.verticalTranslation;
                }
            }
            if (this.dynamicSetting.isRotation !== true) {
                delete this.dynamicSetting.rotation;
            }
            this.saveComponentProperty('dynamicSetting', this.dynamicSetting);
            return true;
        }
        else {
            this.notify.error(this.l('Savedfail'));
            return false;
        }
    };
    TableSettingComponent.prototype.setActiveTab = function (tabId) {
        this.staticTabs.tabs[tabId].active = true;
    };
    TableSettingComponent.prototype.validateChange = function (validatoinResult) {
        this.dynamicValidatoinResult = validatoinResult;
    };
    __decorate([
        ViewChild('displaySettingCmp', { static: false })
    ], TableSettingComponent.prototype, "displaySettingCmp", void 0);
    __decorate([
        ViewChild('staticTabs', { static: false })
    ], TableSettingComponent.prototype, "staticTabs", void 0);
    TableSettingComponent = __decorate([
        Component({
            selector: 'table-setting',
            template: "<div class=\"fe-modal-container\"> <form name='polyLineSettingModal' bs-modal-drag id=\"polyLineSettingModal\" class=\"configure\" *ngIf=\"active\" #straightLineForm=\"ngForm\" novalidate (ngSubmit)=\"save()\"> <div class=\"modal-header fe-modal-header\"> <h4 class=\"fe-modal-header-title\"> {{lc(\"Table\")}} </h4> <div class=\"fe-modal-header-close\" aria-label=\"Close\" (click)=\"closeModal()\">×</div> </div> <div class=\"top-line\"></div> <div class=\"fe-modal-middle\"> <tabset #staticTabs class=\"tab-container tabbable-line\"> <tab heading=\"{{lc('Setting')}}\" customClass=\"m-tabs__item\"> <table-general-setting #generalSettingCmp [data]=\"generalSetting\"></table-general-setting> </tab> <tab heading=\"{{lc('DynamicSetting')}}\" customClass=\"m-tabs__item\" (selectTab)=\"tabSelected(dynamicSettingEventName,configureId)\"> <dynamic-conduct [dynamicSetting]=\"dynamicSetting\" [configureId]='configureId' [viewWidth]=\"viewWidth\" [viewHeight]=\"viewHeight\" (validateChange)=\"validateChange($event);\"></dynamic-conduct> </tab> <tab heading=\"{{lc('Display')}}\" customClass=\"m-tabs__item\" (selectTab)=\"tabSelected(controlSettingEventName,configureId)\"> <display-setting #displaySettingCmp [isFixedPositionVisible]='true' [isAngle]='false'></display-setting> </tab> </tabset> </div> <div class=\"fe-modal-footer\"> <div class=\"button-group\"> <button type=\"submit\" class=\"fe-btn fe-btn-default fe-btn-save\" [disabled]=\"!straightLineForm.form.valid || dynamicValidatoinResult\" [buttonBusy]=\"saving\" [busyText]=\"l('SavingWithThreeDot')\">{{l(\"Save\")}}</button> <button type=\"button\" [disabled]=\"saving\" class=\"fe-btn fe-btn-default fe-btn-cancel-one\" (click)=\"closeModal()\">{{l(\"Cancel\")}}</button> </div> </div> </form> </div>"
        })
    ], TableSettingComponent);
    return TableSettingComponent;
}(ElementSettingModalBase));
export { TableSettingComponent };
